export enum IRATrustTypes {
  UNDER_WILL_TRUST = 'UNDER_WILL_TRUST',
  UNDER_AGREEMENT_TRUST = 'UNDER_AGREEMENT_TRUST',
  EMPTY = '',
}

export const IRATrustTypesMapper = {
  [IRATrustTypes.UNDER_WILL_TRUST]: 'Trust under will/testamentary',
  [IRATrustTypes.UNDER_AGREEMENT_TRUST]: 'Trust under agreement',
};
